import { Subject } from 'rxjs';
import { SearchTableStateEnum } from '../enums/search-table-state.enum';

export class SearchTableViewModel<T> {
  state: SearchTableStateEnum = SearchTableStateEnum.Loaded;

  currentPage: number = 1;

  numberOfTotalResults: number = 0;

  currentNumberOfResults: number = 0;

  numberOfResultsPerPage: number = 25;

  onUpdate = new Subject<SearchTableViewModel<T>>();

  searchText: string = '';

  columns: { keyname: string, text: string }[] = [];

  rows: T[] = [];

  modelUpdated() {
    this.onUpdate.next(this);
  }
}